import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';

const selectLanguagesState = (state: RootState) => state.languages;

export const selectDefaultLanguageCode = createDraftSafeSelector(
  [selectLanguagesState],
  ({ defaultLanguageCode }) => defaultLanguageCode,
);

export const selectAdditionalLanguages = createDraftSafeSelector(
  [selectLanguagesState],
  ({ additionalLanguages }) => additionalLanguages,
);

export const selectLanguageCodes = createDraftSafeSelector(
  [selectLanguagesState],
  ({ defaultLanguageCode, additionalLanguages }) => [
    defaultLanguageCode,
    ...(additionalLanguages?.ids ?? []),
  ],
);

export const selectLanguageByCode = createDraftSafeSelector(
  [
    selectLanguagesState,
    (_state: RootState, languageCode: string) => languageCode,
  ],
  ({ defaultLanguageCode, additionalLanguages }, languageCode) => {
    if (defaultLanguageCode === languageCode) {
      return {
        code: defaultLanguageCode,
        createdAt: '',
        createdBy: '',
        updatedAt: '',
        updatedBy: '',
      };
    }

    return additionalLanguages.entities[languageCode];
  },
);

export const selectLanguagesMetadata = createDraftSafeSelector(
  [selectLanguagesState],
  ({ updatedAt, updatedBy }) => ({ updatedAt, updatedBy }),
);
